import Configs from '@/Configs';

/**
 * Module config for Punch (time tracking), aligned with {@link ADMIN_CONFIG} shape.
 * `name` is the first URL segment (`/punch/...`) used by Layout to pick the module header.
 */
export const PUNCH_V2_CONFIG = {
  name: 'punch',
  icon: 'ClockUser',
  library: 'phosphor',
  routing: {
    self: {
      path: '/punch/punch',
      securityLevel: [Configs.securityLevelIC],
    },
    hr: {
      path: '/punch/myteam/',
      securityLevel: [
        Configs.securityLevelManager,
        Configs.securityLevelHR,
        Configs.securityLevelExec,
        Configs.securityLevelSuperAdmin,
      ],
    },
  },
};

export const AGREEMENT_RULE_CATEGORY = {
  WORKING_HOURS_WEEK: 'WORKING_HOURS_WEEK',
  TIME_OFF_YEAR: 'TIME_OFF_YEAR',
  CARRY_OVER_PER_YEAR: 'CARRY_OVER_PER_YEAR',
  OTHER_LEAVE_YEAR: 'OTHER_LEAVE_YEAR',
  SICK_LEAVE_YEAR: 'SICK_LEAVE_YEAR',
  PERSONAL_LEAVE_YEAR: 'PERSONAL_LEAVE_YEAR',
  MATERNITY_LEAVE_YEAR: 'MATERNITY_LEAVE_YEAR',
  BEREAVEMENT_LEAVE_YEAR: 'BEREAVEMENT_LEAVE_YEAR',
  WEDDING_LEAVE_YEAR: 'WEDDING_LEAVE_YEAR',
  UNPAID_LEAVE_YEAR: 'UNPAID_LEAVE_YEAR',
  WFH_LEAVE_YEAR: 'WFH_LEAVE_YEAR',
  WFH_SICK_LEAVE_YEAR: 'WFH_SICK_LEAVE_YEAR',
  AWARD_LEAVE_YEAR: 'AWARD_LEAVE_YEAR',
};

export const AGREEMENT_RULE_OPERATOR = {
  EQUAL: 'EQUAL',
  GREATER_THAN: 'GREATER_THAN',
  LESS_THAN: 'LESS_THAN',
  GREATER_THAN_OR_EQUAL: 'GREATER_THAN_OR_EQUAL',
  LESS_THAN_OR_EQUAL: 'LESS_THAN_OR_EQUAL',
};

export const AGREEMENT_DAY_OFF_TYPE = {
  LABORAL: 'laboral',
  NATURAL: 'natural',
};

export const AGREEMENT_CONFIG_RULES = {
  Working_Hours_Week: {
    RULE: AGREEMENT_RULE_CATEGORY.WORKING_HOURS_WEEK,
    DISPLAY_IN_DAYS: false,
    SHOW_IN_AGREEMENT: true,
  },
  [Configs.daysOffLeaveTypeVacation]: {
    RULE: AGREEMENT_RULE_CATEGORY.TIME_OFF_YEAR,
    DISPLAY_IN_DAYS: true,
    SHOW_IN_AGREEMENT: true,
    allowedDaysByContract: 'totalDaysPerYear',
    remainingDays: 'remainingDays',
  },
  [Configs.daysOffLeaveTypeCarryOver]: {
    RULE: AGREEMENT_RULE_CATEGORY.CARRY_OVER_PER_YEAR,
    DISPLAY_IN_DAYS: true,
    SHOW_IN_AGREEMENT: true,
    allowedDaysByContract: 'allowedCarryOverDays',
    remainingDays: 'carryOverDaysFromPreviousYear',
  },
  [Configs.daysOffLeaveTypeOther]: {
    RULE: AGREEMENT_RULE_CATEGORY.OTHER_LEAVE_YEAR,
    DISPLAY_IN_DAYS: true,
    SHOW_IN_AGREEMENT: true,
    allowedDaysByContract: 'daysOtherAllowed',
    remainingDays: 'daysOtherRemain',
  },
  [Configs.daysOffLeaveTypeSick]: {
    RULE: AGREEMENT_RULE_CATEGORY.SICK_LEAVE_YEAR,
    DISPLAY_IN_DAYS: true,
    SHOW_IN_AGREEMENT: true,
    allowedDaysByContract: 'daysSickAllowed',
    remainingDays: 'daysSickRemain',
  },
  [Configs.daysOffLeaveTypePersonal]: {
    RULE: AGREEMENT_RULE_CATEGORY.PERSONAL_LEAVE_YEAR,
    DISPLAY_IN_DAYS: true,
    SHOW_IN_AGREEMENT: true,
    allowedDaysByContract: 'daysPersonalAllowed',
    remainingDays: 'daysPersonalRemain',
  },
  [Configs.daysOffLeaveTypeMaternity]: {
    RULE: AGREEMENT_RULE_CATEGORY.MATERNITY_LEAVE_YEAR,
    DISPLAY_IN_DAYS: true,
    SHOW_IN_AGREEMENT: true,
    allowedDaysByContract: 'daysMaternityAllowed',
    remainingDays: 'daysMaternityRemain',
  },
  [Configs.daysOffLeaveTypeUnpaid]: {
    RULE: AGREEMENT_RULE_CATEGORY.UNPAID_LEAVE_YEAR,
    DISPLAY_IN_DAYS: true,
    SHOW_IN_AGREEMENT: true,
    allowedDaysByContract: 'daysUnpaidAllowed',
    remainingDays: 'daysUnpaidRemain',
  },
  [Configs.daysOffLeaveTypeBereavement]: {
    RULE: AGREEMENT_RULE_CATEGORY.BEREAVEMENT_LEAVE_YEAR,
    DISPLAY_IN_DAYS: true,
    SHOW_IN_AGREEMENT: true,
    allowedDaysByContract: 'daysBereavementAllowed',
    remainingDays: 'daysBereavementRemain',
  },
  [Configs.daysOffLeaveTypeWedding]: {
    RULE: AGREEMENT_RULE_CATEGORY.WEDDING_LEAVE_YEAR,
    DISPLAY_IN_DAYS: true,
    SHOW_IN_AGREEMENT: true,
    allowedDaysByContract: 'daysWeddingAllowed',
    remainingDays: 'daysWeddingRemain',
  },
  [Configs.daysOffLeaveTypeWFH]: {
    RULE: AGREEMENT_RULE_CATEGORY.WFH_LEAVE_YEAR,
    DISPLAY_IN_DAYS: true,
    SHOW_IN_AGREEMENT: false,
    allowedDaysByContract: 'daysWFHAllowed',
    remainingDays: 'daysWFHRemain',
  },
  [Configs.daysOffLeaveTypeWFHSick]: {
    RULE: AGREEMENT_RULE_CATEGORY.WFH_SICK_LEAVE_YEAR,
    DISPLAY_IN_DAYS: true,
    SHOW_IN_AGREEMENT: false,
    allowedDaysByContract: 'daysWFHSickAllowed',
    remainingDays: 'daysWFHSickRemain',
  },
  [Configs.daysOffLeaveTypeAward]: {
    RULE: AGREEMENT_RULE_CATEGORY.AWARD_LEAVE_YEAR,
    DISPLAY_IN_DAYS: true,
    SHOW_IN_AGREEMENT: false,
    allowedDaysByContract: 'daysAwardAllowed',
    remainingDays: 'daysAwardRemain',
  },
};
